import React, { Fragment, useEffect, useState } from "react";
import { Bell } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { LI, P, UL } from "../../../AbstractElements";
import { Icon } from "@progress/kendo-react-common";
import { advanceSearch } from "../../../_helper/services/advanceSearchv2";
import { useWebSocket } from "../../../WebsocketManager/WebSocketContext";
import { ShowSucess } from "../../../_helper/helper";
import CloseIcon from '@mui/icons-material/Close';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './Notifications.css';

const Notifications = () => {
  const [response, setResponse] = useState([]);
  const [bannerMessages, setBannerMessages] = useState([]);
  const [showBanner, setShowBanner] = useState(true);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const socketData = useWebSocket();
  const navigate = useNavigate();

  useEffect(() => {
    if (!socketData) return;
    let tempArr = [socketData, ...response];
    setResponse(tempArr);

    let newBannerMessages = [socketData, ...bannerMessages].slice(0, 3);
    setBannerMessages(newBannerMessages);

    if (socketData?.NotificationText)
      ShowSucess("New Notification Alert");
  }, [socketData]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (bannerMessages.length > 1) {
        setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % bannerMessages.length);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [bannerMessages]);

  const payload = {
    id: "dashboard_notifications",
    location: "global",
    tableName: "dashboard_notifications",
    searchParams: "[]",
    columns: "*",
    pageNumber: 1,
    pageSize: 999,
    sortData: "",
    additionalWhere: "",
    qID: 0,
  };

  const getAllNotifications = async () => {
    try {
      const response = await advanceSearch(payload, 'dashboard_notifications');
      const { results } = response;
      setResponse(results);
    } catch (error) {
      // ShowError(error?.message ?? "No Notifications found")
    }
  };

  useEffect(() => {
    getAllNotifications();
  }, []);

  const timeAgo = (date) => {
    const currentDate = new Date();
    const notifiedDate = new Date(date);
    const timeDifference = currentDate - notifiedDate;
    const minutes = Math.floor(timeDifference / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 60) {
      return `${minutes} minutes ago`;
    } else if (hours < 24) {
      return `${hours} hours ago`;
    } else if (days < 7) {
      return `${days} days ago`;
    } else {
      return `${notifiedDate.toLocaleDateString()} ${notifiedDate.toLocaleTimeString()}`;
    }
  };

  const handleCloseBanner = () => {
    setShowBanner(false);
  };

  const handleDotClick = (index) => {
    setCurrentMessageIndex(index);
  };

  const handleNotificationClick = () => {
    navigate('/activity');
  };

  return (
    <Fragment>
      {showBanner && bannerMessages.length > 0 && (
        <div className="notification-banner">
           <TransitionGroup>
            <CSSTransition 
            key={currentMessageIndex}
            classNames="slide"
            timeout={500}>
          <div key={currentMessageIndex} className="notification-banner-message">
            <p>
              <strong>{bannerMessages[currentMessageIndex]?.HR_CONTROL ?? bannerMessages[currentMessageIndex]?.HrControl}: </strong>
              <span onClick={handleNotificationClick} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                {bannerMessages[currentMessageIndex].NotificationText.length > 120 
                  ? `${bannerMessages[currentMessageIndex].NotificationText.substring(0, 120)}...` 
                  : bannerMessages[currentMessageIndex].NotificationText}
              </span>
              <button onClick={handleCloseBanner} className="notification-close-button">
                <CloseIcon fontSize="small" />
              </button>
            </p>
          </div>
          </CSSTransition>
          </TransitionGroup>
          <div className="notification-banner-dots">
            {bannerMessages.map((_, index) => (
              <div
                key={index}
                className={`notification-banner-dot ${currentMessageIndex === index ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
      )}
      <LI attrLI={{ className: "onhover-dropdown" }}>
        <div className="notification-box">
          <Icon style={{ fontSize: '25px' }} className="m-r-10" name="bell" />
          <span className="dot-animated"></span>
        </div>
        <UL attrUL={{ className: "notification-dropdown onhover-show-div" }}>
          <LI>
            <P attrPara={{ className: "f-w-700 m-0" }}>
              You have {response?.length} Notifications
              <span className="pull-right badge badge-primary badge-pill">
                {response?.length}
              </span>
            </P>
          </LI>
          {response?.map((item, index) => (
            <LI key={index} attrLI={{ className: "noti-primary" }}>
              <Link to={`${process.env.REACT_APP_PREFIX_URL}app/email/mailbox`}>
                <div className="media">
                  <div className="media-body">
                    <P>{item?.HR_CONTROL ?? item?.HrControl}</P>
                    <span dangerouslySetInnerHTML={{ __html: item.NotificationText }} />
                    <div style={{ fontSize: "13px", marginTop: "2px" }}>{timeAgo(item.NotifiedOn)}</div>
                  </div>
                </div>
              </Link>
            </LI>
          ))}
        </UL>
      </LI>
    </Fragment>
  );
};

export default Notifications;
